import { c as _c } from "react/compiler-runtime";
import { SleeperFerryPictogram, SleeperTrainPictogram } from '@byway/icons';
import { useTranslations } from 'next-intl';
import type { Transport } from '~/types/JourneyItem.types';
import type { TagItem } from './ItineraryCard.types';
const SLEEPER_TAGS: Partial<Record<Transport, {
  labelKey: string;
  Icon: typeof SleeperTrainPictogram;
}>> = {
  SLEEPER: {
    labelKey: 'transport_sleeper_train_tag',
    Icon: SleeperTrainPictogram
  },
  OVERNIGHT_FERRY: {
    labelKey: 'transport_sleeper_ferry_tag',
    Icon: SleeperFerryPictogram
  }
};
export const useSleeperTag = modes => {
  const $ = _c(10);
  const t = useTranslations("journey");
  let Icon;
  let t0;
  let t1;
  if ($[0] !== modes || $[1] !== t) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const mode = modes.find(_temp);
      const sleeperTag = mode && SLEEPER_TAGS[mode];
      if (!sleeperTag) {
        t1 = null;
        break bb0;
      }
      const {
        labelKey,
        Icon: t2
      } = sleeperTag;
      Icon = t2;
      t0 = t(labelKey);
    }
    $[0] = modes;
    $[1] = t;
    $[2] = Icon;
    $[3] = t0;
    $[4] = t1;
  } else {
    Icon = $[2];
    t0 = $[3];
    t1 = $[4];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  let t2;
  if ($[5] !== Icon) {
    t2 = <Icon size="small" decorative={true} />;
    $[5] = Icon;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t2) {
    t3 = {
      label: t0,
      variant: "hero",
      icon: t2
    };
    $[7] = t0;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(m) {
  return m && SLEEPER_TAGS[m];
}